/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chapter_0Inputs */

const en_chapter_0 = /** @type {(inputs: Chapter_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chapter `)
};

const es_chapter_0 = /** @type {(inputs: Chapter_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capítulo `)
};

const fr_chapter_0 = /** @type {(inputs: Chapter_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chapitre `)
};

const de_chapter_0 = /** @type {(inputs: Chapter_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapitel `)
};

const ja_chapter_0 = /** @type {(inputs: Chapter_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`第 `)
};

const zh_chapter_0 = /** @type {(inputs: Chapter_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`第 章`)
};

const ar_chapter_0 = /** @type {(inputs: Chapter_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفصل `)
};

const id_chapter_0 = /** @type {(inputs: Chapter_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bab `)
};

const it_chapter_0 = /** @type {(inputs: Chapter_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capitolo `)
};

const ru_chapter_0 = /** @type {(inputs: Chapter_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Глава `)
};

const pt_chapter_0 = /** @type {(inputs: Chapter_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capítulo `)
};

const ko_chapter_0 = /** @type {(inputs: Chapter_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`챕터 `)
};

/**
* | output |
* | --- |
* | "Chapter" |
*
* @param {Chapter_0Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const chapter_0 = /** @type {((inputs?: Chapter_0Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chapter_0Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chapter_0(inputs)
	if (locale === "es") return es_chapter_0(inputs)
	if (locale === "fr") return fr_chapter_0(inputs)
	if (locale === "de") return de_chapter_0(inputs)
	if (locale === "ja") return ja_chapter_0(inputs)
	if (locale === "zh") return zh_chapter_0(inputs)
	if (locale === "ar") return ar_chapter_0(inputs)
	if (locale === "id") return id_chapter_0(inputs)
	if (locale === "it") return it_chapter_0(inputs)
	if (locale === "ru") return ru_chapter_0(inputs)
	if (locale === "pt") return pt_chapter_0(inputs)
	return ko_chapter_0(inputs)
});